import { statements } from "@/mocks/homeFeed";
import SectionHeading from "./SectionHeading";

export default function StatementWall() {
  return (
    <section id="statements" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          index="04"
          eyebrow="Statement Wall"
          title="声明汇总：各方原话，不转述只标注"
          desc="谁先说的、谁后改口的，按时间贴在墙上。带核验标记的是公开可查的原文，未标记的仅作记录，不代表本站立场。"
          actionLabel="按时间正序查看声明"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {statements.map((item) => (
            <article
              key={item.id}
              className="rounded-lg bg-background-50 border border-background-200 hover:border-background-300 transition-colors p-5 flex flex-col"
            >
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-full bg-secondary-100 text-secondary-800 font-heading font-bold text-lg flex items-center justify-center shrink-0">
                  {item.party.charAt(0)}
                </span>
                <div className="min-w-0">
                  <div className="font-heading text-base font-semibold text-foreground-950 truncate">
                    {item.party}
                  </div>
                  <div className="mt-0.5 text-xs font-label text-foreground-500">
                    {item.role}
                  </div>
                </div>
                {item.verified ? (
                  <span className="ml-auto shrink-0 inline-flex items-center gap-1 text-[11px] font-label text-accent-800 bg-accent-100 border border-accent-200 rounded-full px-2 py-1 whitespace-nowrap">
                    <i className="ri-checkbox-circle-line text-xs w-3 h-3 flex items-center justify-center" />
                    已核验
                  </span>
                ) : (
                  <span className="ml-auto shrink-0 text-[11px] font-label text-foreground-600 bg-background-100 border border-background-200 rounded-full px-2 py-1 whitespace-nowrap">
                    待核验
                  </span>
                )}
              </div>

              <blockquote className="relative mt-5 pl-5 flex-1">
                <span className="absolute left-0 top-0 w-1 h-full rounded-full bg-primary-200" />
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {item.content}
                </p>
              </blockquote>

              <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between text-xs font-label text-foreground-500">
                <span className="whitespace-nowrap">{item.time}</span>
                <span className="whitespace-nowrap">出处 · {item.source}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}